<template>
  <div>
    <v-row>
      <v-col
        cols="12"
        md="12"
      >
        <div class="d-flex align-center">
          <p class="font-weight-medium mr-3 mb-3">
            Distribution info:
          </p>
          <v-divider />
        </div>
        <base-card>
          <v-card-text class="pa-4">
            <div class="d-flex justify-space-between">
              <div class="pr-4">
                <h5>
                  {{ distribution.name }}
                  <v-btn
                    icon
                    class="m-l-5"
                    color="primary"
                    @click="openPatchNameDialog"
                  >
                    <v-icon class="text-18">
                      mdi-pencil
                    </v-icon>
                  </v-btn>
                </h5>
              </div>
              <img
                style="height:96px;width:96px"
                :src="require('@/assets/images/link.svg')"
              >
            </div>
            <v-data-table
              hide-default-footer
              hide-default-header
              :headers="headers"
              :items="urls"
              class="elevation-1 eg-table-bnone eg-table-td-py-md"
            >
              <template v-slot:item.type="{item}">
                <v-avatar
                  :color="item.type === 'dash' ? 'primary': 'orange'"
                  size="46"
                  class="text-uppercase white--text font-weight-bold"
                >
                  {{ item.type }}
                </v-avatar>
              </template>
              <template v-slot:item.url="{item}">
                <a
                  :href="item.url"
                  target="_blank"
                  class="ma-0 font-weight-medium"
                >
                  {{ item.url }}
                </a>
                <v-btn
                  class="m-l-10"
                  icon
                  @click.stop="handleCopy(item.url)"
                >
                  <v-icon>
                    mdi-content-copy
                  </v-icon>
                </v-btn>
                <v-btn
                  v-if="['hls3', 'hls5', 'hls7'].includes(item.type)"
                  icon
                  color="warning"
                  @click.stop="openPlayer(item.url)"
                >
                  <v-icon>
                    mdi-play
                  </v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </base-card>
      </v-col>
      <v-col
        cols="12"
        md="12"
      >
        <base-card>
          <div class="shadow-none">
            <div
              class="d-flex justify-space-between flex-wrap align-center"
            >
              <v-card-title>
                <div>
                  <h5 class="text-18">
                    IP Whitelist ({{ whitelist.length }})
                  </h5>
                  <p class="text-14">
                    Provide a list of IPv4 hosts/IP networks to be allowed by this distribution. Any changes require up to 30 min to be applied.
                  </p>
                </div>
              </v-card-title>
              <div class="pa-2">
                <v-btn
                  :disabled="loading"
                  color="primary"
                  @click="addWhitelist()"
                >
                  <i class="zmdi zmdi-plus p-r-5" />
                  add
                </v-btn>
              </div>
            </div>
          </div>
          <v-card-text>
            <v-list
              v-if="whitelist.length"
              dense
            >
              <v-list-item-group
                color="primary"
              >
                <v-list-item
                  v-for="(subnet, i) in whitelist"
                  :key="subnet"
                >
                  <v-list-item-content>
                    <v-list-item-title v-text="subnet" />
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-btn
                      icon
                      small
                      @click="openRemoveDialog(i)"
                    >
                      <v-icon color="grey lighten-1">
                        mdi-trash-can
                      </v-icon>
                    </v-btn>
                  </v-list-item-action>
                </v-list-item>
              </v-list-item-group>
            </v-list>
            <p
              v-else
              class="grey--text"
            >
              No data.<br> If no whitelist is defined, URLs are accessible to everyone
            </p>
          </v-card-text>
        </base-card>
      </v-col>
    </v-row>
    <!-- Player -->
    <v-bottom-sheet
      v-model="playerDialog"
      max-width="960"
      :persistent="false"
      inset
    >
      <v-card tile>
        <iframe
          id="serviceFrameSend"
          :src="frameSrc"
          width="100%"
          height="380"
          frameborder="0"
        />
        <v-list>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title class="p-l-20 p-r-20">
                {{ channel.name }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <v-card-actions>
          <v-spacer />
          <v-btn
            depressed
            @click="closePlayer()"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-bottom-sheet>
    <!-- Add Form  -->
    <v-dialog
      v-model="newIPDialog"
      max-width="800px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Add IP addresses to allowlists</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col
                cols="3"
                sm="3"
              >
                <v-radio-group
                  v-model="newSubnet.type"
                  row
                  @change="typeChanged"
                >
                  <v-radio
                    label="host"
                    value="host"
                  />
                  <v-radio
                    label="subnet"
                    value="subnet"
                  />
                </v-radio-group>
              </v-col>
              <v-col
                cols="7"
                sm="7"
              >
                <v-text-field
                  v-model.trim="newSubnet.ip"
                  clearable
                  label="IP"
                  :rules="rules.ipRule"
                  placeholder="192.168.1.1"
                />
                <p
                  v-if="!loading"
                  class="red--text"
                >
                  {{ alreadyAddedIP() }}
                </p>
              </v-col>
              <v-col
                cols="2"
                sm="2"
              >
                <v-text-field
                  v-model.trim="newSubnet.mask"
                  label="Mask"
                  :disabled="newSubnet.type === 'host'"
                  :rules="rules.maskRule"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="blue darken-1"
            text
            @click="newIPDialog = false"
          >
            Close
          </v-btn>
          <v-btn
            color="primary"
            :disabled="loading || !isSubnetFormValid"
            @click="addSubnet()"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Remove Dialog -->
    <v-dialog
      v-model="removeDialog"
      max-width="500"
      persistent
    >
      <v-card>
        <v-card-title class="text-h5">
          Delete IP?
        </v-card-title>
        <v-card-text>
          <div class="row p-b-20">
            <div class="col-md-12">
              Are you sure you want to delete the IP "{{ whitelist[deletedSubnet] }}"?
            </div>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            depressed
            text
            @click="removeDialog = false"
          >
            No
          </v-btn>
          <v-btn
            depressed
            color="error"
            @click="deleteSubnet()"
          >
            Yes
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Patch Name Form  -->
    <v-dialog
      v-model="patchNameDialog"
      max-width="800px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">New Distribution Name</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col
                cols="12"
                sm="12"
              >
                <v-text-field
                  v-model="patchedName"
                  label="Name*"
                  :counter="255"
                  :rules="rules.nameRules"
                  required
                />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="blue darken-1"
            text
            @click="patchNameDialog = false"
          >
            Close
          </v-btn>
          <v-btn
            color="primary"
            :disabled="loading || !isPatchNameFormValid"
            @click="updateName()"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import { processChannel, processDistribution } from '@/store/converters'
  import { setClipboard, ipAddressRegExp } from '@/helpers/utils'

  export default {
    metaInfo: {
      title: 'Distribution Details',
    },
    data () {
      return {
        channel: {
          id: 0,
          logo: '',
          name: '',
        },
        distribution: {},
        headers: [
          {
            text: '',
            align: 'start',
            sortable: false,
            value: 'type',
          },
          { text: '', value: 'url' },
        ],
        urls: [],
        whitelist: [],
        frameSrc: '',
        playerDialog: false,
        newIPDialog: false,
        newSubnet: {
          type: 'host',
          ip: '',
          mask: '32',
        },
        deletedSubnet: null,
        removeDialog: false,
        patchNameDialog: false,
        patchedName: '',
        rules: {
          nameRules: [
            v => !!v || 'Name is required',
            v => (v.length >= 3 && v.length <= 255) || 'Name must be between 3 and 255 characters',
          ],
          ipRule: [
            v => (!v || ipAddressRegExp.test(v.trim().toString())) || 'Invalid IP',
          ],
          maskRule: [
            v => !!v || 'required',
            v => (v >= 16 && v <= 32) || '16-32',
          ],
        },
      }
    },
    computed: {
      loading () {
        return this.$store.getters.isDataLoaded
      },
      isSubnetFormValid () {
        const ip = this.newSubnet.ip || ''
        if (!ipAddressRegExp.test(ip.toString())) {
          return false
        }
        return this.newSubnet.mask >= 16 && this.newSubnet.mask <= 32
      },
      isPatchNameFormValid () {
        if (!(this.patchedName.length >= 3 && this.patchedName.length <= 255)) {
          return false
        }
        return true
      },
    },
    watch: {
      '$route' (to, from) {
        if (to.params.id) {
          this.getChannelInfo(to.params.id)
        }
      },
    },
    created () {
      const channelId = this.$route.params.id
      this.channel.id = channelId

      this.getChannelInfo(channelId)
    },
    methods: {
      getChannelInfo (id) {
        this.$store.commit('setPageLoader')

        const args = {
          ids: id,
        }
        const channelReq = this.$store.dispatch('channels', args)

        return Promise.all([channelReq])
          .then((res) => {
            const channels = res[0]
            this.channel = processChannel(channels[0])

            const distribId = this.$route.params.distribution_id

            this.getDistribution(distribId)
          })
          .catch((errorMsg) => {
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
            })
            this.$router.push({ name: 'DashboardPage' })
          })
      },
      getDistribution (id) {
        this.$store.commit('setPageLoader')

        const args = {
          'id[eq]': id,
        }
        const distribReq = this.$store.dispatch('distributions', args)

        return Promise.all([distribReq])
          .then((res) => {
            const distributions = res[0]
            this.distribution = processDistribution(distributions[0])
            for (const key in this.distribution.urls) {
              if (['hls3', 'hls5', 'hls7', 'dash'].includes(key)) {
                this.urls.push({
                  type: key,
                  url: this.distribution.urls[key],
                })
              }
            }
            this.whitelist = this.distribution.whitelist
          })
          .catch((errorMsg) => {
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
            })
            this.$router.push({ name: 'Distributions' })
          })
          .finally(() => {
            this.$store.commit('resolvePageLoader')
          })
      },
      handleCopy (text) {
        setClipboard(text)
        this.$store.commit('showSnackbar', {
          text: 'URL has been copied',
          timeout: 6000,
          color: 'success',
        })
      },
      openPlayer (url) {
        this.setFrameSrc(url)
        this.playerDialog = true
      },
      setFrameSrc (url) {
        if (!url) return
        const link = url.replace(/^http:\/\//, 'https://')
        this.frameSrc = `/js/radiant/index.html?src=${link}`
      },
      closePlayer () {
        this.playerDialog = false
        this.setFrameSrc('')
      },
      typeChanged () {
        if (this.newSubnet.type === 'host') {
          this.newSubnet.mask = 32
        }
      },
      addWhitelist () {
        this.newSubnet.type = 'host'
        this.newSubnet.ip = ''
        this.newSubnet.mask = '32'
        this.newIPDialog = true
      },
      addSubnet () {
        const newSubnet = `${this.newSubnet.ip}/${this.newSubnet.mask}`
        for (let i = 0; i < this.whitelist.length; i += 1) {
          if (this.whitelist[i] === newSubnet) {
            return
          }
        }
        this.$store.commit('setPageLoader')

        const whitelist = JSON.parse(JSON.stringify(this.whitelist))
        whitelist.push(newSubnet)

        const distrib = {
          id: this.distribution.id,
          whitelist: whitelist,
        }

        this.$store.dispatch('updateDistribution', distrib)
          .then(() => {
            this.$store.commit('showSnackbar', {
              text: 'The IP has been successfully added to whitelist',
              timeout: 6000,
              color: 'success',
            })
            this.whitelist.push(newSubnet)
          })
          .catch((errorMsg) => {
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
            })
          })
          .finally(() => {
            this.newIPDialog = false
            this.$store.commit('resolvePageLoader')
          })
      },
      alreadyAddedIP () {
        const newSubnet = `${this.newSubnet.ip}/${this.newSubnet.mask}`
        for (let i = 0; i < this.whitelist.length; i += 1) {
          if (this.whitelist[i] === newSubnet) {
            return 'Selected IP is already added'
          }
        }
        return ''
      },
      openRemoveDialog (i) {
        this.deletedSubnet = i
        this.removeDialog = true
      },
      deleteSubnet () {
        this.$store.commit('setPageLoader')

        const whitelist = JSON.parse(JSON.stringify(this.whitelist))
        whitelist.splice(this.deletedSubnet, 1)

        const distrib = {
          id: this.distribution.id,
          whitelist: whitelist,
        }

        this.$store.dispatch('updateDistribution', distrib)
          .then(() => {
            this.$store.commit('showSnackbar', {
              text: 'The IP has been successfully removed from whitelist',
              timeout: 6000,
              color: 'success',
            })
            this.whitelist.splice(this.deletedSubnet, 1)
          })
          .catch((errorMsg) => {
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
            })
          })
          .finally(() => {
            this.removeDialog = false
            this.$store.commit('resolvePageLoader')
          })
      },
      openPatchNameDialog () {
        this.patchedName = this.distribution.name
        this.patchNameDialog = true
      },
      updateName () {
        this.$store.commit('setPageLoader')

        const distrib = {
          id: this.distribution.id,
          name: this.patchedName,
        }

        this.$store.dispatch('patchDistribution', distrib)
          .then(() => {
            this.$store.commit('showSnackbar', {
              text: 'The name has been successfully updated',
              timeout: 6000,
              color: 'success',
            })
            this.distribution.name = this.patchedName
          })
          .catch((errorMsg) => {
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
            })
          })
          .finally(() => {
            this.patchNameDialog = false
            this.$store.commit('resolvePageLoader')
          })
      },
    },
  }
</script>

<style>
</style>
